import React from 'react';
import './HomePage.css';
import { useEffect, useRef, useState } from "react"
import NavbarCapacita from '../../components/NavbarCapacita/NavbarCapacita';
import Footer from '../../components/footer/Footer';
import { useNavigate } from 'react-router-dom';
import { validateToken } from "../../services/AuthService"
import { SessionExpiredCard } from "../../components/SessionExpiredCard"
import Button from '../../components/button/Button';

const HomePage = () => {
    const token = localStorage.getItem("site")
    const [isValidate, setIsValidate] = useState(true)

    const navigate = useNavigate();
    const timeoutRef = useRef()

    const handleIniciarClick = () => {
        navigate('/training');
    };

    useEffect(() => {
        setIsValidate(true)
        if (token) {            
            validateToken(token)
                .then((response) => {
                    if (response.status === 200) setIsValidate(true)
                })
                .catch((err) => {
                    if (err.response && err.response.status) {
                        setIsValidate(false)
                        timeoutRef.current = setTimeout(() => {
                            navigate("/login")
                        }, 4000)
                    }
                })
        } else {
            setIsValidate(false)
            navigate("/login")
        }
    }, [token, navigate])

    return (
        <>
            {isValidate ? (
                <>
                    <div className="home-container">
                        <NavbarCapacita />
                        <div className="home-content">
                            <img src='/images/Confetti_Fondo.png' alt='img_welcome' className="welcome-image"/>
                            <h1>¡Bienvenido!</h1>
                            <p>
                            En Mabe, apostamos por el crecimiento de nuestros transportistas para asegurar entregas eficientes y de alta calidad.
                            Mabe Capacita es un espacio de aprendizaje diseñado para que conozcas y apliques las mejores prácticas de la compañía,
                            brindando una experiencia de entrega excepcional a nuestros clientes.
                            </p>
                            <h1>Instrucciones</h1>
                            <p>1. Abre las capacitaciones dando click en “iniciar”.</p>
                            <p>2. Al finalizar de ver todas las capacitaciones deberás realizar la evaluación correspondiente.</p>
                            <Button onClick={handleIniciarClick}>
                                INICIAR
                            </Button>
                        </div>
                        <Footer />
                    </div>
                </>
            ) : (
                <SessionExpiredCard />
            )}
        </>
    );
}

export default HomePage;